<template>
    <p>
        This site is protected by reCAPTCHA and the Google
        <a href="https://policies.google.com/privacy" class="underline">Privacy Policy</a> and
        <a href="https://policies.google.com/terms" class="underline">Terms of Service</a> apply.
    </p>
</template>
